import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import flatpickr from "flatpickr";
import locale from "flatpickr/dist/l10n/pt";
import { useCallback, useEffect, useRef, useState } from "react";
import { Button } from "../Button";
import { Icon } from "../Icon";
import { isTheSameDateRange, pickerOptions } from "./helpers";
import { DatePickerContainer, DatePickerGlobalStyles, DatePickerInput } from "./styles";
import "flatpickr/dist/themes/light.css";
import { FormFieldWrapper } from "../../core/shared/FormFieldWrapper";
import { Flex } from "../Flex";
import { Loading } from "../Loading";
flatpickr.localize(locale.pt);
export function DatePicker({ name, label, onChange, initialValue = [], loading, forceClearInput = false, clearButton, feedback, }) {
    const [pickerValue, setPickerValue] = useState(initialValue);
    const [toggleClearButton, setToggleClearButton] = useState(!!initialValue);
    const mountedRef = useRef(false);
    const datePickerRef = useRef(null);
    const handleReady = (_, __, fp) => {
        fp.calendarContainer.classList.add("date-picker");
    };
    const handleClearCalendar = (clearValue) => {
        datePickerRef.current?.flatpickr.clear();
        setPickerValue(clearValue);
        setToggleClearButton(false);
    };
    const handleValueChange = useCallback((selected) => {
        if (!toggleClearButton && selected?.length)
            setToggleClearButton(true);
        if (!pickerValue?.length || !isTheSameDateRange(selected || [], pickerValue)) {
            onChange?.({ currentTarget: { value: selected, name } });
        }
    }, [pickerValue]);
    useEffect(() => {
        if (mountedRef.current && forceClearInput) {
            handleClearCalendar();
        }
    }, [forceClearInput]);
    useEffect(() => {
        if (mountedRef.current && pickerValue !== undefined) {
            handleValueChange(pickerValue);
        }
        mountedRef.current = true;
    }, [handleValueChange]);
    return (_jsx(FormFieldWrapper, { label: label, name: name, value: pickerValue, onChangeFeedback: () => { }, type: "text", loading: loading, feedback: feedback, children: _jsxs(DatePickerContainer, { children: [_jsx(DatePickerGlobalStyles, {}), _jsx(Icon, { name: "calendar_month", color: "--text-disable" }), _jsx(DatePickerInput, { id: name, name: name, ref: datePickerRef, onReady: handleReady, options: pickerOptions, placeholder: "Data inicial - Data final", onClose: (selected) => setPickerValue(selected), value: pickerValue, "data-testid": "date-picker-input", className: feedback?.type === "error" ? "feedback-error" : "", disabled: loading }), clearButton && toggleClearButton && !loading && (_jsx(Button, { className: "clear-button", variant: "none", onClick: () => handleClearCalendar([]), children: _jsx(Icon, { name: "close", color: "--text-disable" }) })), loading && (_jsx(Flex, { margin: "0 0 0 -48px", children: _jsx(Loading, {}) }))] }) }));
}
//# sourceMappingURL=index.js.map